import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { acceptInvite } from 'project/ducks/collaborators';
import AcceptCollaborationInvite from 'project/components/accept_collaboration_invite';

const mapStateToProps = (state, {
  params: { projectId, inviteId, inviteKey },
  location: { query }
}) => ({
  registering: query && query.registration == 'true',
  accepted: state.project.collaborators.data.inviteAccepted,
  inviteProject: state.project.collaborators.data.inviteProject,
  projectId,
  inviteId,
  inviteKey
});

export default withRouter(connect(mapStateToProps, {
  accept: acceptInvite
})(AcceptCollaborationInvite));



// WEBPACK FOOTER //
// ./project/containers/accept_collaboration_invite.js